/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_od_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How does A260 give concentration?`)
};

const es_od_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo da la A260 la concentración?`)
};

const de_od_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie ergibt A260 die Konzentration?`)
};

const nl_od_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe geeft A260 de concentratie?`)
};

const fr_od_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment l'A260 donne-t-il la concentration ?`)
};

const it_od_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come dà l'A260 la concentrazione?`)
};

const pt_br2_od_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como o A260 fornece a concentração?`)
};

const pt_od_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como é que A260 dá a concentração?`)
};

const ja_od_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A260からどのように濃度が得られますか？`)
};

const zh_od_faq_q1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A260 是如何得出浓度的？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const od_faq_q1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.od_faq_q1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("od_faq_q1", locale)
	if (locale === "en") return en_od_faq_q1(inputs)
	if (locale === "es") return es_od_faq_q1(inputs)
	if (locale === "de") return de_od_faq_q1(inputs)
	if (locale === "nl") return nl_od_faq_q1(inputs)
	if (locale === "fr") return fr_od_faq_q1(inputs)
	if (locale === "it") return it_od_faq_q1(inputs)
	if (locale === "pt-BR") return pt_br2_od_faq_q1(inputs)
	if (locale === "pt") return pt_od_faq_q1(inputs)
	if (locale === "ja") return ja_od_faq_q1(inputs)
	return zh_od_faq_q1(inputs)
};